<main [style.backgroundImage]="splashData.splashImage">
  <div class="content">
    <h1 [innerHTML]="projectName"></h1>
    <h3>Visual Simulations</h3>
    <a [routerLink]="'/' + home" class="btn home-btn">enter</a>
    <div class="splashBox" [innerHTML]="splashData.splashText"></div>
  </div>
</main>